import React from 'react';
import { Container, Heading, RichText } from './StyledHeadingWithDescription';

export type HeadingWithDescriptionProps = {
  headingField: any;
  descriptionField: any;
  headingLevel: any;
};

const HeadingWithDescription: React.FC<HeadingWithDescriptionProps> = ({
  headingField,
  descriptionField,
  headingLevel
}) => {
  headingLevel = headingLevel?.value || 'h2';

  return (
    <Container>
      {headingField && (
        <Heading
          tag={typeof headingLevel === 'number' ? `h${headingLevel}` : headingLevel}
          field={headingField}
        />
      )}
      {descriptionField && <RichText field={descriptionField} />}
    </Container>
  );
};

export default HeadingWithDescription;
